import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Register from '../auth/Register';
import Login from '../auth/Login';


function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography component='div'>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`,
	};
}

const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		marginTop: 10,
	},
	text: {
		fontFamily: 'Poppins',
	},
}));
const AuthenticationComp = (props) => {

	const location = useLocation();

	const defaultEmailVal =  location?.state?.email;

	// check whether there is a default email value or tab value otherwise set default tab to 0 (Register)
	let defaultTabVal = defaultEmailVal || location?.state?.tab  ?  1 : 0;
	
	
	const { t } = useTranslation();
	const classes = useStyles();
	const theme = useTheme();
	const [value, setValue] = React.useState(defaultTabVal);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleChangeIndex = index => {
		setValue(index);
	};
	return (
		<div className={classes.root}>
			<AppBar position='static' color='default'>
				<Tabs
					value={value}
					onChange={handleChange}
					indicatorColor='primary'
					variant='fullWidth'
					aria-label='full width tabs example'
				>
					<Tab
						label={t('register')}
						{...a11yProps(0)}
						className={classes.text}
					/>
					<Tab label={t('login')} {...a11yProps(1)} className={classes.text} />
				</Tabs>
			</AppBar>
			<SwipeableViews
				axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
				index={value}
				onChangeIndex={handleChangeIndex}
			>
				<TabPanel value={value} index={0} dir={theme.direction}>
					<Register />
				</TabPanel>
				<TabPanel value={value} index={1} dir={theme.direction}>
					<Login defaultEmailVal={defaultEmailVal} />
				</TabPanel>
			</SwipeableViews>
		</div>
	);
};

export default AuthenticationComp;
